import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { saveTemplate } from '../../services/templateManager';
import Loader from '../loader';
import { addNotification } from '../../action/notificationAction';

export default class TemplateModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            template: { name: "", templateString: "" }
        };
        // this.name = createRef();
        // this.template = createRef();
    }

    onSubmit = async () => {
        this.setState({ isLoading: true });
        try {
            await saveTemplate(this.props.selectedCompanyID, this.state.template.name, this.state.template.templateString);
            addNotification({ status: "success", message: "Successfully added template" });
            this.onHandleClose();
        } catch (error) {
            this.setState({ isLoading: false });
            addNotification({ status: "fail", message: "Failed adding template" });
        }

    };
    onChangeHandler = (ev) => {
        const name = ev.target.name;
        const value = ev.target.value;
        this.setState((prevState) => ({ template: { ...prevState.template, [name]: value } }));
        console.log(name);
        console.log(value);
    };
    onHandleClose = () => {
        this.setState({ isLoading: false, template: { name: "", templateString: "" } }, () => {
            this.props.handleClose();
        });
    };
    render() {
        const { isLoading } = this.state;
        return <Modal show={this.props.isShow} onHide={this.onHandleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Template</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? <Loader /> :
                    <Form>
                        <Form.Group>
                            <Form.Label>
                                Template name
                    </Form.Label>
                            <Form.Control
                                onChange={this.onChangeHandler}
                                name="name"
                            />

                        </Form.Group>
                        <Form.Group>
                            <Form.Label>
                                Template
                    </Form.Label>
                            <Form.Control
                                onChange={this.onChangeHandler}
                                name="templateString"
                                as="textarea" rows={8} />

                        </Form.Group>
                    </Form>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={isLoading} variant="danger" onClick={this.onHandleClose}>Cancel</Button>
                <Button disabled={isLoading} variant="success" onClick={this.onSubmit}>Submit template</Button>
            </Modal.Footer>
        </Modal>;
    }

};


// WEBPACK FOOTER //
// ./src/components/template/templateModal.js